import { useEffect, useState } from "react"
import { Action, PanelLoader } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoadmapList } from "./roadmapList"
import { DeliveryRoadmap, Roadmap } from "../../../state/types"
import { useRoadmapLoaders } from "../../../loaders/roadmapLoaders"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { dedupe } from "../../../../../utils/listUtils"
import { Delivery, DeliveryOrder, useDeliveryLoaders, useDeliveryOrderLoaders } from "../../../../deliveries"

export const RoadmapListLoader = () => {
    const [roadmaps, setRoadmaps] = useState<Roadmap[]>([])
    const [deliveryRoadmaps, setDeliveryRoadmaps] = useState<DeliveryRoadmap[]>([])
    const [shipments, setShipments] = useState<Delivery[]>([])
    const [shipmentOrders, setShipmentOrders] = useState<DeliveryOrder[]>([])
    const [ready, setReady] = useState(false)

    const { getRoutePath } = useRoutesHooks()

    const roadmapLoaders = useRoadmapLoaders()
    const deliveryLoaders = useDeliveryLoaders()
    const deliveryOrderLoaders = useDeliveryOrderLoaders()

    const populate = async () => {
        const { loadAllRoadmaps, loadRoadmapsDeliveriesLinks } = roadmapLoaders()
        let loadedRoadmaps = await loadAllRoadmaps(true)
        let loadedDeliveryRoadmaps = await loadRoadmapsDeliveriesLinks(loadedRoadmaps.map(roadmap => roadmap.id), true)
        const { loadDeliveries } = deliveryLoaders()
        const deliveryIds = dedupe(loadedDeliveryRoadmaps.map(deliveryRoadmap => deliveryRoadmap.deliveryId))
        const loadedDeliveries = await loadDeliveries(deliveryIds)
        const { loadDeliveryOrders } = deliveryOrderLoaders()
        const loadedDeliveryOrders = await loadDeliveryOrders(loadedDeliveries.map(delivery => delivery.orderId!))
        loadedDeliveryRoadmaps = loadedDeliveryRoadmaps.filter(deliveryRoadmap => loadedDeliveries.some(delivery => delivery.id === deliveryRoadmap.deliveryId))
        loadedRoadmaps = loadedRoadmaps.filter(roadmap => loadedDeliveryRoadmaps.some(deliveryRoadmap => deliveryRoadmap.roadmapId === roadmap.id))
        setRoadmaps(loadedRoadmaps)
        setDeliveryRoadmaps(loadedDeliveryRoadmaps)
        setShipments(loadedDeliveries)
        setShipmentOrders(loadedDeliveryOrders)
    }

    useEffect(() => {
        setReady(false)
        populate().then(() => setReady(true))
    }, [])

    const headerActions: Action[] = [
        { label: 'Lista de Envios', kind: 'tertiary', href: getRoutePath(RoutePath.SHIPMENT_ORDERS) }
    ]

    return (
        <PanelLoader
            title="Hojas de Ruta"
            ready={ready}
            actions={headerActions}
            wide
            titleRight={<BookmarkButton routePath={RoutePath.ROADMAPS} />}
        >
            <RoadmapList
                roadmaps={roadmaps}
                deliveryRoadmaps={deliveryRoadmaps}
                shipments={shipments}
                shipmentOrders={shipmentOrders}
            />
        </PanelLoader>
    )
}
